// extracted by mini-css-extract-plugin
module.exports = {"componentsRow":"-components-container-componentsRow-UAMW-O-","componentInRow":"-components-container-componentInRow-OwhXdH-"};